import { render } from "./CarouselCaption.vue?vue&type=template&id=f46d30a6&scoped=true"
import script from "./CarouselCaption.vue?vue&type=script&lang=js"
export * from "./CarouselCaption.vue?vue&type=script&lang=js"

import "./CarouselCaption.vue?vue&type=style&index=0&id=f46d30a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f46d30a6"],['__file',"src/components/mdbvue/Advanced/CarouselCaption.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f46d30a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f46d30a6', __exports__)) {
    api.reload('f46d30a6', __exports__)
  }
  
  module.hot.accept("./CarouselCaption.vue?vue&type=template&id=f46d30a6&scoped=true", () => {
    api.rerender('f46d30a6', render)
  })

}


export default __exports__